import React from 'react';
import { ImageZoomProps } from '../../navigation/types';

const ImageZoom: React.FC<ImageZoomProps> = ({}) => {
  return null;
};

export default ImageZoom;
